import {
GET_VOUCHER_SALE,
GET_TOTAL_STOCK,
INVOICE_LIST,
INVOICE_DOWNLOAD,
INVOICE_UPDATE,
GENERATE_INVOICE,
CLEAR_INVOICE_PREVIEW,
DELETE_DELEIVERY_NOTE
} from "../../admin-constants";
import ReportService from "../../../services/admin/report.service";
import { showLoader,hideLoader } from "../../common/actions";
import { hideModal, showModal } from "../../modal/actions";

export const getVoucherSale = (data) => async (dispatch) => {
  try {
    const resultData = await ReportService.getVoucherSale(data);
    if (resultData?.status) {
      dispatch({
        type: GET_VOUCHER_SALE,
        payload: resultData,
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getTotalStock = (data) => async (dispatch) => {
  try {
    const resultData = await ReportService.getTotalStock(data);
    if (resultData?.status) {
      dispatch({
        type: GET_TOTAL_STOCK,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const viewInvoice = (data) => async (dispatch) => {
  try {
    const resultData = await ReportService.viewInvoice(data);
    if (resultData?.status) {
      dispatch({
        type: INVOICE_LIST,
        payload: resultData?.status && resultData?.data ? resultData.data : [],
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const downloadInvoice = (data) => async (dispatch) => {
  try {
    const resultData = await ReportService.downloadInvoice(data);
    if (resultData) {
      dispatch({
        type: INVOICE_DOWNLOAD,
        payload: resultData,
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const updateInvoice = (data) => async (dispatch) => {
  try {
                dispatch(showLoader());

    const resultData = await ReportService.updateInvoice(data.data);
    if (resultData?.status) {
      dispatch({
        type: INVOICE_UPDATE,
        payload: data,
      });

                                     dispatch(showModal({
                  title: "Success",
                  message: "Updated successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }else{
            dispatch(showModal({
                  title: "Failure",
                  message: resultData.message.message,
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }
  } catch (err) {
    console.log(err);
  }
  finally {
      dispatch(hideLoader());
    }
};

export const generateInvoice = (data) => async (dispatch) => {
  try {
            dispatch(showLoader());

    const resultData = await ReportService.generateInvoice(data);

    if (resultData?.status) {
      dispatch({
        type: GENERATE_INVOICE,
        payload: {
          deliverynoteids: Array.isArray(data.deliverynoteid)
            ? data.deliverynoteid
            : [data.deliverynoteid],
        },
      });

                               dispatch(showModal({
                  title: "Success",
                  message: "Invoice Generated Successfully",
                  iconType: "success",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }else{
            dispatch(showModal({
                  title: "Failure",
                  message: "Something wrong while updating",
                  iconType: "error",
                  autoClose: true,
                  autoCloseTime: 1800,
                }));
    }
  } catch (err) {
    console.log(err);
  }
  finally {
      dispatch(hideLoader());
    }
};


export const clearInvoicePreview = () => ({
  type: CLEAR_INVOICE_PREVIEW,
});



export const deleteDeliveryNote = (data) => async (dispatch) => {
  try {

    dispatch(showLoader());
  
    const resultData = await ReportService.deleteDeliveryNote(data);
    dispatch(hideModal());

    if (resultData?.status) {
    
      dispatch({
        type: DELETE_DELEIVERY_NOTE,
        payload: data,
      });

      dispatch(showModal({
        title: "Success",
        message: "Deleted Successfully",
        iconType: "success",
        autoClose: true,
        autoCloseTime: 1800,
      }));
    }else{
        dispatch(showModal({
              title: "Failure",
              message: "Something wrong while updating",
              iconType: "error",
              autoClose: true,
              autoCloseTime: 1800,
            }));
    }
  } catch (err) {
    console.log(err);
  }
  finally {
      dispatch(hideLoader());
    }
};